
import {mapGetters, mapMutations} from 'vuex';
import { analyticsTrack } from '../../vue/plugins/segment';
import { WebstoreResources } from './webstore-resources';

export const UpdateShoppingCartHandlers = {

    data() {
        return {
        }
    },

    mixins:[WebstoreResources],

    computed: {
        ...mapGetters('shoppingCart', [
            'productsInCart',
        ]),

        ...mapGetters('content', [
            'webstoreContent',
        ]),

        ...mapGetters([
            'isCableSelectionActive',
        ]),

        totalCablesSubmittedData() {
            return this.$store.getters[
                `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/totalCablesSubmittedData`
            ];
        },
    },

    methods: {
        ...mapMutations('shoppingCart', [
            'addOfferToProductsInCart',
            'removeOfferFromProductsInCart',
            'updateSelectedOfferQuantity',
        ]),

        ...mapMutations([
            "setBagStep",
            "setActiveProductTabDefault"
        ]),

        doesSelectedPlusInCartQuantityExceedMax(activeOffer, selectedQuantity) {

            if (!selectedQuantity || !activeOffer || !activeOffer.maxPurchasableQuantity) {
                return false
            }

            if (selectedQuantity > activeOffer.maxPurchasableQuantity) {
                return true;
            }

            for (let offer of this.productsInCart) {
                if (offer.offerName === activeOffer.offerName) {
                    if (offer.quantity + selectedQuantity > offer.maxPurchasableQuantity) {
                        return true;
                    }
                }
            }
            return false;
        },

        fireOfferMaxQuantityExceededAlert(activeOffer) {
            this.$fire({
                title: this.webstoreContent.webstoreAlerts.max_quantity_exceeded.title,
                text: this.webstoreContent.webstoreAlerts.max_quantity_exceeded.text.replace('max_purchasable_quantity', activeOffer.maxPurchasableQuantity),
                type: "error"
            });
        },

        addOfferToProductsInCartHandler: function(activeOffer, selectedQuantity, cableData) {
            if (!this.activeProductKey.includes("CBL") && this.doesSelectedPlusInCartQuantityExceedMax(activeOffer, selectedQuantity)) {
                this.fireOfferMaxQuantityExceededAlert(activeOffer);
            } else {
                this.addOfferToProductsInCart({...activeOffer, quantity: selectedQuantity, cables: cableData});
            }
        },

        updateSelectedOfferQuantityHandler(activeOffer, selectedQuantity, cableData) {
            if (!this.activeProductKey.includes("CBL") && this.doesSelectedPlusInCartQuantityExceedMax(activeOffer, selectedQuantity)) {
                this.fireOfferMaxQuantityExceededAlert(activeOffer.maxPurchasableQuantity);
                this.quantity = activeOffer.maxPurchasableQuantity;
            }
            this.updateSelectedOfferQuantity({...activeOffer, quantity: selectedQuantity, cables: cableData});
        },

        removeSelectedOfferQuantityHandler(activeOffer) {
            this.removeOfferFromProductsInCart(activeOffer);
            this.$store.commit(`${activeOffer.productKey}/setQuantity`, 0)
            if (this.isCableSelectionActive) {
                this.$store.commit(`${activeOffer.productKey}${activeOffer.offerKey}CableSelection/vin/clearSubmittedVinData`);
                this.$store.commit(`${activeOffer.productKey}${activeOffer.offerKey}CableSelection/manualSelection/clearManualSelectionData`);
                this.$store.commit(`${activeOffer.productKey}${activeOffer.offerKey}CableSelection/mmy/clearSubmittedMMYData`);
                this.$store.commit(`${activeOffer.productKey}${activeOffer.offerKey}CableSelection/base/setCablesNeededCount`);
                this.$store.commit(`${activeOffer.productKey}${activeOffer.offerKey}CableSelection/base/setCablesSelectedCount`);
            }
            analyticsTrack("Bag Updated", { "products": this.productsInCart })
        },

        addSafetyEventReviewLicense(currentKey, currentQuantity) {
            this.addOfferToProductsInCart(
                {
                    defaultPaymentTerm: "month",
                    discount: 0,
                    included: ['Safety Event Review License (LIC-SER)'],
                    listPrice: [{code:'LIC-SVC-CM-Review-ENT', price: this.safetyEventReviewPrice}],
                    maxPurchasableQuantity: 200,
                    monthlyUnitPrice: true,
                    offerImage: undefined,
                    offerKey: "License",
                    offerName: `Safety Event Review License - ${currentKey.replace('-VG54', '')}`,
                    offerType: "License",
                    productCodes: ['LIC-SVC-CM-Review-ENT'],
                    productFamily: "CM",
                    productKey: this.webstoreContent.cartPage.ser_sku,
                    productStatus: "GA",
                    salesPrice: [{code:'LIC-SVC-CM-Review-ENT', price: this.safetyEventReviewPrice}],
                    quantity: currentQuantity,
                },
                currentQuantity,
                {}
            );
        },

        fireIncorrectCablesSelectedCountAlert: function(cablesSelectedCount, cablesNeededCount) {
            this.$fire({
                title: this.webstoreContent.webstoreAlerts.incorrect_number_of_cables_selected.title,
                text: this.webstoreContent.webstoreAlerts.incorrect_number_of_cables_selected.text.replace("cables_selected_count", cablesSelectedCount).replace("cables_needed_count", cablesNeededCount),
                type: "error"
            });
        },

        updateCart () {
            if (!this.activeProductKey.includes("CBL") && this.isCableSelectionActive && this.cablesNeededCount !== this.totalCablesSubmittedCount) {
              this.fireIncorrectCablesSelectedCountAlert(
                this.cablesSelectedCount,
                this.cablesNeededCount
              );
              return false;
            }
        
            let cableData = this.isCableSelectionActive
              ? this.totalCablesSubmittedData
              : {};

            // Activate crosssell modal for CMs
            if (this.activeProductKey === 'VG54' && this.activeOffer.offerType.includes('Fleet')) {
              this.showCM31 = this.isENT ? this.productCatalog['CM']['CM31-VG54']['offerings']['License + Hardware']['monthlyUnitPrice'] : true
              this.showCM32 = this.isENT ? this.productCatalog['CM']['CM32-VG54']['offerings']['License + Hardware']['monthlyUnitPrice'] : true
              if (this.showCM31 || this.showCM32) {
                this.isModalVisible = true;
                document.body.style.position = 'fixed';
              }
            }

            // Save current key to clear quantity after we have cleared activeProductKey
            let currentKey = this.activeProductKey
            let currentQuantity = this.currentQuantity
            let safetyEventReviewActive = this.isSafetyEventReviewActive

            if (this.existingOfferInCart && this.currentQuantity === 0) {
              this.removeSelectedOfferQuantityHandler(this.activeOffer);
              this.setActiveProductKeyInactive();
              this.setActiveProductFamilyInactive();
            } else if (this.existingOfferInCart) {
                if (this.activeProductKey.includes("CBL") && this.activeProductKey !== 'CBL-VG-CAUX') {
                    for(let offerInfo of this.cablesSelected){
                        this.updateSelectedOfferQuantityHandler(
                            offerInfo.offer,
                            offerInfo.quantity,
                            []
                        );
                    }
                } else {
                    this.updateSelectedOfferQuantityHandler(
                        this.activeOffer,
                        this.currentQuantity,
                        cableData
                    );
                }
            } else {
                if (this.activeProductKey.includes("CBL") && this.activeProductKey !== 'CBL-VG-CAUX') {
                    for(let offerInfo of this.cablesSelected){
                        this.addOfferToProductsInCartHandler(
                            offerInfo.offer,
                            offerInfo.quantity,
                            []
                        );
                    }
                this.cablesSelected = [];
              } else {
                this.addOfferToProductsInCartHandler(
                    this.activeOffer,
                    this.currentQuantity,
                    cableData
                );
              }
            }

            // Add safety event review license 
            if (safetyEventReviewActive) {
                this.addSafetyEventReviewLicense(currentKey, currentQuantity);
            }

            // Clear the general quantity value after adding to cart

            // Reset product keys / add to cart
            if (!this.isModalVisible) {
                this.productAddedToCart()
            }
        
            analyticsTrack("Bag Updated", { products: this.productsInCart });
          },
    },
}